import { FormGroup } from "@angular/forms";
import { Contact } from "../../../business-objects/contact/contact.model";

export interface IContactControlModel {
    formGroup?: FormGroup;
    contact?: Contact;
    contacts?: Array<Contact>;
    account?: Account;
}

export abstract class ViewModel<ViewModelArgs> {
    protected abstract defaults: () => ViewModelArgs;

    protected initialize(args: ViewModelArgs): void {
        args = Object.assign({}, this.defaults(), args);
        Object.keys(args).forEach(key => this[`_${key}`] = args[key]);
    }

    get values(): ViewModelArgs {
        const values = { } as ViewModelArgs;
        Object.keys(this.defaults()).forEach(key => values[key] = this[`_${key}`]);
        return values;
    }
}

export class ContactControlModel extends ViewModel<IContactControlModel> {
    protected _formGroup: FormGroup;
    protected _contact: Contact;
    protected _contacts: Array<Contact>;
    protected _account: Account;

    protected defaults = () => ({
        formGroup: undefined,
        contact: undefined,
        contacts: [],
        account: undefined
    } as IContactControlModel);
    
    constructor(args: IContactControlModel = { } as any) {
        super();
        this.initialize(args);
    }

    get account(): Account {
        return this._account;
    }

    get contact(): Contact {
        return this._contact;
    }

    get contacts(): Array<Contact> {
        return this._contacts;
    }

    get formGroup(): FormGroup {
        return this._formGroup;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/contact/form/contact-control.model.ts